import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { Connections } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ConnectionsService extends TmsWebBaseEditService<Connections, Connections> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('Connections', $localize`Connections`, httpService, notificationService);
  }
}
